import { DocumentSource } from '@insurance/api/requests'
import { SelectProps } from 'antd'
import { TFunction } from 'i18next'

export const sourceList = Object.values(DocumentSource)

export const sourceOptions = (t: TFunction): SelectProps['options'] =>
  sourceList.map((value) => ({
    label: t(`source_${value}`),
    value
  }))
